export const TRANSFER_AGGREGATION_TITLE = 'PROJECTS_MODULE.transferrequest.aggregationTransferTitle';
export const TRANSFER_AGGREGATION_DESC = 'PROJECTS_MODULE.transferrequest.aggregationTransferDesc';
